import { render, staticRenderFns } from "./RemoveAccountWindow.vue?vue&type=template&id=27f89398&scoped=true&"
import script from "./RemoveAccountWindow.vue?vue&type=script&lang=js&"
export * from "./RemoveAccountWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f89398",
  null
  
)

export default component.exports